import Vue from 'vue'
import JsonExcel from 'vue-json-excel'

Vue.component('downloadExcel', JsonExcel)

Vue.filter('toFixed', function(value) {
  // return value.toFixed(2)
  return value.substring(0, value.indexOf('.') + 3)
})
